/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ title, canonicalUrl = "https://www.epochconverter.io", siteMetadata }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            description2
            keywordsContent        
            siteUrl
          }
        }
      }
    `
  )
  if (!siteMetadata) {
    siteMetadata = site.siteMetadata
  }
  const metaDescription = siteMetadata.description
  const metaDescription2 = siteMetadata.description2
  const keywordsContent = siteMetadata.keywordsContent

  return (
    <>
      <html lang="en"/>
      <title>{title}</title>
      <meta name="description" content={metaDescription}/>
      <meta name="keywords" content={keywordsContent}/>
      <meta name="og:description" content={metaDescription2}/>
      <meta httpEquiv="Content-type" content={`text/html;charset=UTF-8`}/>
      <link rel="canonical" href={canonicalUrl}/>
    </>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default Seo
